import {  
    deleteNiceResultInLocalStorage,
    getlocalStorageNiceResult,
} from '../utils/nice';

export const NiceMixin = {
    methods: {
        niceGetResult(){
            let result = getlocalStorageNiceResult();
            deleteNiceResultInLocalStorage();
            return result
        },
    },
};